<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">CHÍNH SÁCH QUYỀN RIÊNG TƯ</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `Chính sách Quyền riêng tư này áp dụng cho ứng dụng Argus, do Duc Chien Bank Material Equipment Company Limited phát triển và vận hành.
Argus là ứng dụng hỗ trợ người dùng thực hiện cuộc gọi công việc, quản lý nhiệm vụ, ghi nhận kết quả liên hệ, xác minh thông tin công việc và theo dõi quá trình chăm sóc khách hàng. Chúng tôi tôn trọng quyền riêng tư của người dùng và chỉ xử lý dữ liệu trong phạm vi cần thiết để cung cấp và bảo vệ các chức năng của ứng dụng.
1. Thông tin được xử lý
Trong quá trình sử dụng Argus, chúng tôi có thể xử lý các thông tin sau:
- Thông tin tài khoản như họ tên, số điện thoại, email, tên đăng nhập hoặc mã nhân viên;
- Thông tin nhiệm vụ, tiến độ và trạng thái công việc;
- Thông tin khách hàng được phân công hoặc do người dùng chủ động nhập;
- Nội dung ghi chú, kết quả cuộc gọi, lịch hẹn và lịch sử chăm sóc khách hàng;
- Dữ liệu vị trí tại thời điểm người dùng thực hiện xác minh rủi ro hoặc chấm công;
- Hình ảnh giấy tờ, hồ sơ hoặc tài liệu do người dùng chủ động chụp hoặc tải lên thông qua camera;
- Thông tin kỹ thuật như loại thiết bị, phiên bản hệ điều hành, địa chỉ IP, nhật ký đăng nhập và báo cáo lỗi.
Argus không tự động truy cập hoặc thu thập dữ liệu trên thiết bị ngoài phạm vi cần thiết cho các chức năng đã được thông báo.
2. Quyền truy cập micro
Argus có thể yêu cầu quyền sử dụng micro để hỗ trợ:
- Thực hiện cuộc gọi phục vụ công việc;
- Nhập nội dung bằng giọng nói;
Micro chỉ được kích hoạt khi người dùng chủ động mở và sử dụng chức năng liên quan. Argus không tự động bật micro, không nghe âm thanh xung quanh và không ghi âm ngầm khi người dùng không sử dụng chức năng này.
Nội dung âm thanh chỉ được xử lý trong phạm vi cần thiết cho thao tác mà người dùng lựa chọn. Dữ liệu âm thanh không được sử dụng cho quảng cáo, theo dõi người dùng ngoài ứng dụng hoặc xây dựng hồ sơ tiếp thị.
Trường hợp người dùng sử dụng chức năng lưu nội dung âm thanh hoặc ghi nhận cuộc gọi, người dùng có trách nhiệm thông báo cho người tham gia cuộc gọi khi pháp luật yêu cầu.
Người dùng có thể từ chối hoặc thu hồi quyền micro trong phần cài đặt của thiết bị. Khi quyền này bị tắt, một số chức năng liên quan đến cuộc gọi hoặc giọng nói có thể không hoạt động, nhưng các chức năng khác vẫn có thể tiếp tục được sử dụng.
3. Quyền truy cập vị trí
Argus có thể yêu cầu quyền truy cập vị trí để:
- Xác minh vị trí trong quá trình kiểm soát rủi ro;
- Kiểm tra tính phù hợp của hoạt động đăng nhập hoặc sử dụng tài khoản;
- Ghi nhận chấm công tại địa điểm làm việc;
- Hỗ trợ xác minh việc thực hiện nhiệm vụ tại khu vực được phân công.
Vị trí chỉ được truy cập khi người dùng chủ động sử dụng chức năng xác minh hoặc chấm công. Tùy thuộc vào chức năng, Argus có thể xử lý vị trí hiện tại, thời gian xác minh và kết quả đối chiếu với địa điểm làm việc hoặc khu vực được phân công.
Argus không liên tục theo dõi hành trình của người dùng, không tự động thu thập vị trí khi không cần thiết và không sử dụng dữ liệu vị trí cho quảng cáo hoặc tiếp thị.
Người dùng có thể từ chối hoặc thu hồi quyền vị trí trong phần cài đặt của thiết bị. Khi quyền này bị tắt, chức năng xác minh vị trí, kiểm soát rủi ro hoặc chấm công có thể không thực hiện được, nhưng các chức năng không cần vị trí vẫn có thể tiếp tục được sử dụng.

4.Quyền truy cập camera
Argus có thể yêu cầu quyền truy cập camera để hỗ trợ người dùng:
- Chụp hình ảnh giấy tờ, hồ sơ hoặc tài liệu cần thiết cho công việc;
- Tải lên hình ảnh tài liệu thông qua chức năng được cung cấp trong ứng dụng;
- Xác nhận hoặc ghi nhận thông tin công việc bằng hình ảnh khi cần thiết.
Camera chỉ được truy cập khi người dùng chủ động mở và sử dụng chức năng chụp hoặc tải lên hình ảnh. Argus không tự động bật camera, không chụp ảnh và không truy cập camera khi người dùng không sử dụng các chức năng này.
Hình ảnh chỉ được xử lý trong phạm vi cần thiết để hoàn thành chức năng mà người dùng đã lựa chọn. Argus không sử dụng hình ảnh cho mục đích quảng cáo, tiếp thị, theo dõi người dùng ngoài ứng dụng hoặc xây dựng hồ sơ tiếp thị.
Người dùng có thể từ chối hoặc thu hồi quyền camera trong phần cài đặt của thiết bị. Khi quyền này bị tắt, một số chức năng chụp hoặc tải lên hình ảnh có thể không hoạt động, nhưng các chức năng khác không cần sử dụng camera vẫn có thể tiếp tục được sử dụng.
5. Quyền gửi thông báo
Argus có thể gửi thông báo nhằm hỗ trợ người dùng theo dõi công việc, bao gồm:
- Nhắc lịch gọi lại khách hàng;
- Thông báo nhiệm vụ mới hoặc nhiệm vụ sắp đến hạn;
- Cập nhật trạng thái xử lý công việc;
- Cảnh báo liên quan đến tài khoản và bảo mật;
- Thông báo cập nhật hoặc bảo trì hệ thống.
Quyền thông báo không cho phép Argus truy cập dữ liệu cá nhân khác trên thiết bị.
Người dùng có thể cho phép, giới hạn hoặc tắt thông báo bất kỳ lúc nào trong phần cài đặt của iOS. Việc tắt thông báo không ảnh hưởng đến khả năng đăng nhập, nhưng người dùng có thể không nhận được lời nhắc công việc đúng thời điểm.
6. Mục đích sử dụng thông tin
Thông tin được xử lý để:
- Xác thực và quản lý tài khoản;
- Phân quyền sử dụng ứng dụng;
- Hỗ trợ cuộc gọi và nhập nội dung;
- Quản lý nhiệm vụ và quá trình chăm sóc khách hàng;
- Xác minh vị trí phục vụ kiểm soát rủi ro;
- Ghi nhận chấm công và xác nhận việc thực hiện nhiệm vụ;
- Gửi lời nhắc và thông báo công việc;
- Bảo vệ tài khoản và ngăn chặn truy cập trái phép;
- Phát hiện, khắc phục lỗi và duy trì hoạt động ổn định của Argus;
- Xử lý yêu cầu hỗ trợ hoặc khiếu nại;
- Thực hiện nghĩa vụ theo quy định pháp luật.
Chúng tôi không bán hoặc cho thuê dữ liệu cá nhân, dữ liệu âm thanh hoặc dữ liệu vị trí của người dùng và khách hàng.
7. Chia sẻ thông tin
Dữ liệu chỉ có thể được chia sẻ trong phạm vi cần thiết với:
- Nhân sự hoặc bộ phận có thẩm quyền của Công ty;
- Người quản lý tài khoản hoặc quản lý công việc;
- Nhà cung cấp máy chủ, lưu trữ và hỗ trợ kỹ thuật;
- Nhà cung cấp dịch vụ hỗ trợ chức năng âm thanh hoặc vị trí, nếu có;
- Cơ quan nhà nước có thẩm quyền khi có yêu cầu hợp pháp.
Các bên cung cấp dịch vụ chỉ được xử lý dữ liệu để thực hiện nhiệm vụ được giao và phải áp dụng các biện pháp bảo mật phù hợp.
8. Lưu trữ và bảo vệ thông tin
Dữ liệu được lưu giữ trong thời gian cần thiết để cung cấp dịch vụ, quản lý công việc, xác minh hoạt động, giải quyết khiếu nại và thực hiện nghĩa vụ pháp lý.
Dữ liệu vị trí liên quan đến chấm công hoặc xác minh rủi ro chỉ được lưu giữ cùng với hồ sơ công việc tương ứng trong thời gian cần thiết cho mục đích quản lý và kiểm tra.
Chúng tôi áp dụng các biện pháp bảo mật phù hợp, bao gồm:
- Kiểm soát quyền truy cập theo tài khoản và vai trò;
- Mã hóa dữ liệu trong quá trình truyền tải;
- Giám sát hoạt động đăng nhập bất thường;
- Hạn chế nhân sự được phép truy cập dữ liệu;
- Sao lưu, cập nhật và bảo vệ hệ thống.
Khi dữ liệu không còn cần thiết, dữ liệu sẽ được xóa, ẩn danh hoặc hạn chế truy cập theo quy trình phù hợp.
9. Quyền của người dùng
Trong phạm vi pháp luật áp dụng, người dùng có quyền:
- Truy cập hoặc yêu cầu chỉnh sửa thông tin cá nhân;
- Thu hồi sự đồng ý đã cung cấp;
- Tắt quyền micro, vị trí hoặc thông báo;
- Yêu cầu hạn chế hoặc xóa dữ liệu khi đủ điều kiện;
- Gửi câu hỏi, phản ánh hoặc khiếu nại về việc xử lý dữ liệu.
Việc thu hồi quyền vị trí có thể làm gián đoạn chức năng chấm công hoặc xác minh rủi ro. Đối với dữ liệu công việc, một số yêu cầu có thể cần được xác nhận bởi bộ phận quản lý có thẩm quyền.
10. Trách nhiệm của người dùng
Khi sử dụng Argus, người dùng có trách nhiệm:
- Cung cấp và nhập thông tin chính xác;
- Chỉ sử dụng thông tin khách hàng cho mục đích công việc hợp pháp;
- Không chia sẻ dữ liệu cho người không có thẩm quyền;
- Bảo mật tài khoản và thông tin đăng nhập;
- Không làm sai lệch vị trí hoặc kết quả chấm công;
- Không sử dụng Argus để quấy rối, lừa đảo hoặc liên hệ trái phép;
- Thông báo cho Công ty khi phát hiện dấu hiệu mất tài khoản hoặc rò rỉ dữ liệu.
11. Thay đổi Chính sách Quyền riêng tư
Chúng tôi có thể cập nhật Chính sách này khi chức năng của Argus, phương thức xử lý dữ liệu hoặc quy định pháp luật thay đổi.
Nội dung cập nhật sẽ được công bố trong ứng dụng hoặc thông qua kênh thông tin phù hợp. Nếu có thay đổi quan trọng liên quan đến quyền truy cập thiết bị, Argus sẽ hiển thị thông báo trước khi áp dụng.
12. Thông tin liên hệ
Nếu có câu hỏi, yêu cầu hoặc khiếu nại liên quan đến Chính sách Quyền riêng tư, vui lòng liên hệ:
Tên công ty: Duc Chien Bank Material Equipment Company Limited
Địa chỉ: No. 244A, Thuy Khue Street, Thuy Khue Ward, Ha Noi, Vietnam
Email: support@ducchienbank.com`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3200px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -300px auto 100px;
  height: 5800px;
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  /* border: 2px solid #F6660B; */
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4D64E4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "SF Pro Display";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
</style>
